module.exports = "pegasus/assets/themelp1/tickets/103.png";